/*
  Measures .allied-header-section and publishes its rendered height as the
  --allied-header-height custom property on the document root, so other
  CSS in the theme (fixed-header offsets, scroll-padding, sticky sidebars,
  etc.) can read it without duplicating/hardcoding the header's height.

  Prefixed --allied-* (matching the .allied-header-section class itself) so
  it doesn't collide with an unrelated --header-height some plugin or
  vendor stylesheet might already define.

  Uses ResizeObserver rather than only a window 'resize' listener: it also
  catches height changes that aren't driven by the window resizing at all
  (the header wrapping to two lines, a banner toggled inside it, a webfont
  swap), and it fires once immediately on observe() so a separate 'load'
  handler isn't needed.
*/
var HEADER_HEIGHT_SELECTOR = '.allied-header-section';
var HEADER_HEIGHT_CSS_VAR = '--allied-header-height';

function setHeaderHeightVar(header) {
    var height = header ? header.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty(HEADER_HEIGHT_CSS_VAR, height + 'px');
}

document.addEventListener('DOMContentLoaded', function () {
    var header = document.querySelector(HEADER_HEIGHT_SELECTOR);

    if (!header) {
        return;
    }

    if (window.ResizeObserver) {
        new ResizeObserver(function () {
            setHeaderHeightVar(header);
        }).observe(header);
    } else {
        // Fallback for browsers without ResizeObserver support.
        setHeaderHeightVar(header);
        window.addEventListener('resize', function () {
            setHeaderHeightVar(header);
        });
    }
});